import React from 'react';

import { OnboardingBuildingDialog } from './onboarding-building.dialog';
import { OnboardingZoneDialog } from './onboarding-zone.dialog';
import { OnboardingCompanyDialog } from './onboarding-company.dialog';
import { OnboardingDecalDialog } from './onboarding-decal.dialog';
import { OnboardingEmployeeDialog } from './onboarding-employee.dialog';
import { OnboardingReviewDialog } from './onboarding-review.dialog';
import { useOnboardingContext } from './onboarding.context.hook';
import { EOnboardingStep } from 'enums';

export const OnboardingDialogs = () => {
  const { status } = useOnboardingContext();
  return (
    <>
      <OnboardingBuildingDialog visible={status === EOnboardingStep.SETUP_BUILDING} />
      <OnboardingZoneDialog visible={status === EOnboardingStep.SETUP_ZONE} />
      <OnboardingCompanyDialog visible={status === EOnboardingStep.COMPANY_BRAND_SETTING} />
      <OnboardingDecalDialog visible={status === EOnboardingStep.APPROVE_DECAL} />
      <OnboardingEmployeeDialog visible={status === EOnboardingStep.ASSIGN_EMPLOYEE} />
      <OnboardingReviewDialog visible={status === EOnboardingStep.ONBOARDING_REVIEW} />
    </>
  );
};
